import { initBotId } from 'botid/client/core';

initBotId({
  protect: [
    {
      path: '/api/game/spin',
      method: 'POST',
    },
  ],
});
